/* eslint-disable camelcase */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../helpers/ApiHelper';
import { AppConfig } from '../../AppConfig';
import { BaseEntityPageSlixta } from '../../components/BaseEntityPageSlixta';
import { Helper } from '../helpers/Helper';
import { UiHelper } from '../helpers/UiHelper';
import { Controller } from '../Controller';
import { AppHelper } from '../../helpers/AppHelper';
import { AppStyles } from '../../styles/AppTheme';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';

export class UserActivity extends BaseEntityPageSlixta {

  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageKey = 'user-activity'
    this.pageTitle = Helper.getString('user-activity')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = this.props.match.params.subOrgId || ''
    this.userId = this.props.match.params.userId || ''
    this.staffSubOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.staffUserId = Controller.get().getUserId()
    this.apiData = {
      orgId: this.orgId,
    }
    this.staffUsers = []
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: Helper.getString('staff-activity'), to: `${this.baseRoute()}/staff-activity` },
      { title: this.userId },
    ]
    // this.showMoreLimit = 1000
    this.toFetch = [
      { key: 'staffActivity', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-staff-activity'], queryParams: { orgId: this.orgId, staffUserId: this.userId, limit: 100 } },
      { key: 'usersORG', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: { orgId: this.orgId, parentOrgId: this.orgId } },
      { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), pb: 'fieldDef', includeCustomFields: 'true', limit: 0, 'tags!': 'INTERNAL' } },
      { key: 'crmaccounts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmaccounts'], queryParams: { orgId: this.orgId, ...(this.subOrgId && {subOrgId: this.subOrgId}), pb: 'fieldDef', includeCustomFields: 'true', limit: 0, 'tags!': 'INTERNAL' } },
      { key: 'crmaccountnames', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-crm-account-titles'], queryParams: { orgId: this.orgId } },
    ]
    if (AppHelper.isTeamsEnabled(this.orgId) && !this.subOrgId) {
      this.toFetch.push({ key: 'suborgs', method: 'GET', paths: ['orgs'], queryParams: { parentOrgId: this.orgId } })
    }
    this.cellWidths = {
      Index: Styles.cellWidthSmall,
      Date: Styles.cellWidthNormal,
      Info: Styles.cellWidthWide,
    }
    const _self = this
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Date: (current) => { return Helper.formatTimestamp(current.createdTs) },
      Info: (current) => {
        let summary = ''
        const creator = current.creatorName || Helper.formatName(_self.staffUsers.find(u => u.id === current.creatorId || u.userId === current.creatorId))
        summary = summary + `<div>${creator && <span className={css(Styles.line2)}>Creator: {creator}</span>}</div>`

        switch (current.entityType) {
        case 'CRMACCOUNT':
        {
          const entityName = (current.payload && current.payload.entityName) || ''
          if (entityName) { summary = summary + `<div>Entity: ${current.payload.entityName}</div>` }
          summary = summary + UiHelper.getUpdateDiffSummary(current, _self.crmAccountFieldDef);
          break;
        }
        case 'CRMCONTACT':
        {
          const entityName = (current.payload && current.payload.entityName) || ''
          if (entityName) { summary = summary + `<div>Entity: ${current.payload.entityName}</div>` }
          summary = summary + UiHelper.getUpdateDiffSummary(current, _self.crmContactFieldDef);
          break;
        }
        }

        return (
          <div className={css(Styles.infoCell)}>
            {current.activityType && <div className={css(Styles.line2)}>Activity: {current.activityType}</div>}
            {current.subActivityType && <div className={css(Styles.line2)}>Type: {current.subActivityType}</div>}
            <span className={css(Styles.line2, Styles.summaryContainer)} id={'id_' + current.__index} dangerouslySetInnerHTML={{ __html: summary }}></span>
          </div>
        )
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.headerActions = [
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      }
    ]
    this.noAdd = true
  }

  onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    const staffActivityResponse = this.getResult(results, 'staffActivity') || {items: []}
    if (!fetchNext) {
      this.usersORG = this.getResult(results, 'usersORG').items || []
      this.staffUsers = this.usersORG.filter(u => u.orgId === (this.staffSubOrgId || this.orgId))
      this.orgUser = this.usersORG.find(u => u.userId === this.userId)
      this.currentStaffUser = this.staffUsers.find(u => u.userId === this.staffUserId) || {}
      this.staffActivity = staffActivityResponse.items || []
      this.crmContactFieldDef = this.getResult(results, 'crmcontacts').fieldDef
      this.crmAccountFieldDef = this.getResult(results, 'crmaccounts').fieldDef
      this.crmAccountNames = this.getResult(results, 'crmaccountnames')
      this.subOrgs = this.getResult(results, 'suborgs') ? this.getResult(results, 'suborgs').items : []
      UiHelper.populateOptions(this.crmContactFieldDef, {items: this.staffUsers}, 'assignee')
      UiHelper.populateOptions(this.crmContactFieldDef, {items: this.crmAccountNames}, 'accounts')
      UiHelper.populateOptions(this.crmContactFieldDef, {items: this.crmAccountNames}, 'primaryAccountId')
      UiHelper.populateOptions(this.crmContactFieldDef, {items: this.subOrgs}, 'subOrgId')
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute() },
        { title: Helper.getString('staff-activity'), to: `${this.baseRoute()}/staff-activity` },
        { title: Helper.formatName(this.orgUser) },
      ]
    } else {
      this.staffActivity = (this.staffActivity || []).concat(staffActivityResponse.items || [])
    }
    this.handleNextpage(staffActivityResponse)
    this.setState({
      items: this.staffActivity,
      staffUsers: this.staffUsers || this.state.staffUsers,
      currentStaffUser: this.currentStaffUser || this.state.currentStaffUser,
      orgUser: this.orgUser || this.state.orgUser,
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions = (current) => {
    const actions = []
    if(current && current.entityType === 'CRMCONTACT' && current.entityId) {
      const userId = current.entityId.includes('-') ? current.entityId.split('-')[1] : ''
      actions.push(
        <Link to={this.baseRoute() + '/crm-contacts/' + userId} key={'viewcontact-' + userId}>
          <Tooltip title='View Contact' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>person</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    return actions
  }
}

const Styles = StyleSheet.create({
  infoCell: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10
  },
  line1: {
    fontSize: 16,
  },
  line2: {
    fontSize: 12,
    color: 'grey'
  },
  summaryContainer: {
    wordBreak: 'break-word'
  },
  cellWidthSmall: {
    width: '10%',
  },
  cellWidthNormal: {
    width: '20%',
  },
  cellWidthWide: {
    width: '50%',
  },
})